<div style="height: 100%">
  <div
    class="is-flex is-align-items-top"
    style="height: 100%; padding-top: 32px"
  >
    <button
      (click)="isMapVisible = true"
      type="button"
      class="button is-link is-light is-block is-small"
      style="
        padding: 0 9px;
        line-height: 1 !important;
        height: 32px !important;
        font-size: 18px;
        background-color: #d1dff5;
      "
    >
      <i class="fa-solid fa-crosshairs"></i>
    </button>
  </div>

  <div class="modal" [ngClass]="{ 'is-active': isMapVisible }">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 80vw; max-width: 1000px">
      <header class="modal-card-head">
        <p
          class="modal-card-title m-0"
          translationEditableDirective="PICK_COORDINATES"
        >
          {{ 'PICK_COORDINATES' | translate }}
        </p>
        <button
          class="delete"
          aria-label="close"
          (click)="isMapVisible = false"
        ></button>
      </header>
      <section class="modal-card-body">
        <div class="map-wrapper">
          <div id="ol-layer" class="ol-map"></div>
        </div>

        <div class="buttons pt-4">
          <button
            type="button"
            translationEditableDirective="SAVE"
            class="button is-primary"
            contenteditable="false"
            (click)="onSave()"
            [disabled]="!position?.length"
          >
            {{ 'SAVE' | translate }}
          </button>
        </div>
      </section>
    </div>
  </div>
</div>
